import type { BadgeVariant } from '@elara/client-core/ui-contracts/badge-variant';

import { cva } from 'class-variance-authority';

// Variant *names* are shared with data models via @elara/client-core (ELARA-700); this maps each
// name to its Tailwind classes. The `Record<BadgeVariant, string>` annotation keeps the two in sync.
const BadgeVariants: Record<BadgeVariant, string> = {
  default: 'border-transparent bg-primary text-primary-foreground',
  secondary: 'border-transparent bg-secondary text-secondary-foreground',
  destructive: 'border-transparent bg-destructive text-destructive-foreground',
  info: 'border-transparent bg-blue-100 text-blue-800',
  success: 'border-transparent bg-green-100 text-green-800 dark:bg-green-500/15 dark:text-green-400',
  affiliate: 'border-transparent bg-accent text-accent-foreground',
  outline: 'text-foreground',
};

const BadgeSizes = {
  sm: 'px-2 py-0.25 text-2xs',
  default: 'px-2.5 py-0.5 text-xs',
  lg: 'px-3 py-1 text-sm',
};

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: { variant: BadgeVariants, size: BadgeSizes },
    defaultVariants: { variant: 'default', size: 'default' },
  },
);

export type { BadgeVariant } from '@elara/client-core/ui-contracts/badge-variant';
export type BadgeSize = keyof typeof BadgeSizes;
